import { DialogTitle } from "@headlessui/react";

import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import SessionInfo from "@/components/auth/SessionInfo.tsx";
import { IconWarningMark } from "@/components/icons";

import { useSuspenseSessions } from "@/hooks/api/login.hooks.ts";

const AuthSessionsModal = () => {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const token = params.get("token");
  const { data } = useSuspenseSessions(token ?? "");

  const [isDisabled, setIsDisabled] = useState<boolean>(false);

  if (!token) return <></>;

  return (
    <div>
      <div className={"flex flex-col items-center justify-center gap-5 max-md:gap-4"}>
        <IconWarningMark className={"size-[3.125rem]"} />
        <div className={"flex flex-col items-center gap-[0.938rem] text-center max-md:gap-2"}>
          <DialogTitle as={"h2"} className={"text-2xl font-semibold leading-6"}>
            {t("Sessions.above-limit")}
          </DialogTitle>
          <p className={"w-[80%] text-lg max-md:text-base"}>{t("Sessions.about-limit-message")}</p>
        </div>
      </div>
      <ul className={"mt-10 flex max-h-[400px] flex-col space-y-5 overflow-auto  max-lg:mt-6 max-md:space-y-2"}>
        {data.map((session) => {
          return (
            <li key={session.my_key}>
              <SessionInfo {...session} token={token} isDisabled={isDisabled} setIsDisabled={setIsDisabled} />
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default AuthSessionsModal;
